import type { Release } from '../releases';

export default {
  id: '2026-11-01-site-day-quantity',
  at: '2026-11-01T11:03:00Z',
  title: 'Площадка: объём на день из сменного задания и отклонение факта',
  modules: ['site'],
  items: [
    'Если руководитель выдал прорабу сменное задание, в «Моём дне» у работы видно «На день: 12,5 м3», а в отчёте смены — план на день по заданию.',
    'Когда прораб вводит выполненный объём, портал сразу показывает отклонение: «+1,5 м3 к плану (112 %)» или «−2 м3 до плана (84 %)»; при недоборе просит объяснить в комментарии, что помешало.',
    'Принятый отчёт смены по-прежнему закрыт для правки.',
  ],
  why: 'Прораб не видел, сколько нужно сделать за смену, а руководитель не мог сразу сравнить факт с планом дня.',
  link: '/site/day',
} satisfies Release;
